// Javascript's MAX_VALUE cannot be correctly serialized via JSON. Pick another
// sufficiently large value that will serialize correctly.
export default 99999999;